const sortAlphabetically = (array, attr) =>
    array.sort((a, b) => a[attr].localeCompare(b[attr].toLowerCase()));

export default sortAlphabetically;
